import { useMemo, useState } from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";

const tesseraNum = (t) => parseInt(String(t || "").replace(/^#/, "").split("/")[0], 10) || 0;

const empty = (v) => v == null || v === "";

const cmp = (a, b, dir) => {
  if (empty(a)) return empty(b) ? 0 : 1;
  if (empty(b)) return -1;
  const r = typeof a === "number" && typeof b === "number" ? a - b : String(a).localeCompare(String(b), "it", { sensitivity: "base", numeric: true });
  return dir === "desc" ? -r : r;
};

export const useSort = (items, getters, initial = null) => {
  const [sort, setSort] = useState(initial);
  const sorted = useMemo(() => {
    if (!sort) return items;
    const get = getters[sort.key] || ((x) => x[sort.key]);
    return [...items].sort((a, b) => cmp(get(a), get(b), sort.dir));
  }, [items, sort, getters]);
  const toggle = (key) => setSort((s) => (s?.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));
  return { sorted, sort, toggle };
};

export const byTessera = (x) => tesseraNum(x.tessera_numero) || null;

export const SortHead = ({ k, label, s, prefix }) => {
  const active = s.sort?.key === k;
  const Icon = !active ? ArrowUpDown : s.sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <TableHead aria-sort={active ? (s.sort.dir === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" onClick={() => s.toggle(k)} className={`inline-flex items-center gap-1 hover:text-foreground transition-colors ${active ? "text-foreground font-semibold" : ""}`} data-testid={`${prefix}-sort-${k}`}>
        {label}<Icon className={`h-3.5 w-3.5 ${active ? "" : "opacity-40"}`} />
      </button>
    </TableHead>
  );
};
